import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { AspectRatioWrapper } from '../../../components';

import howItWorksImageFirst from '../images/how-it-works-img-1.png';
import howItWorksImageSecond from '../images/how-it-works-img-2.png';
import howItWorksImageThird from '../images/how-it-works-img-3.png';

import css from './SectionHowItWorks.module.css';

const IMAGE_ASPECT_WIDTH = 3;
const IMAGE_ASPECT_HEIGHT = 2;

const stepItem = (title, text, image) => {
  return (
    <div className={css.step}>
      <AspectRatioWrapper width={IMAGE_ASPECT_WIDTH} height={IMAGE_ASPECT_HEIGHT}>
        <img className={css.stepImage} src={image} alt={title} />
      </AspectRatioWrapper>
      <h4 className={css.stepTitle}>{title}</h4>
      <p className={css.stepText}>{text}</p>
    </div>
  );
};

const SectionHowItWorks = props => {
  const { className, rootClassName, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <h2 className={css.title}>
        <FormattedMessage id="LandingPage.SectionHowItWorks.title" />
      </h2>
      <p className={css.text}>
        <FormattedMessage id="LandingPage.SectionHowItWorks.text" />
      </p>
      <div className={css.steps}>
        {stepItem(
          intl.formatMessage({
            id: 'LandingPage.SectionHowItWorks.step1Title',
          }),
          intl.formatMessage({
            id: 'LandingPage.SectionHowItWorks.step1Text',
          }),
          howItWorksImageFirst
        )}
        {stepItem(
          intl.formatMessage({
            id: 'LandingPage.SectionHowItWorks.step2Title',
          }),
          intl.formatMessage({
            id: 'LandingPage.SectionHowItWorks.step2Text',
          }),
          howItWorksImageSecond
        )}
        {stepItem(
          intl.formatMessage({
            id: 'LandingPage.SectionHowItWorks.step3Title',
          }),
          intl.formatMessage({
            id: 'LandingPage.SectionHowItWorks.step3Text',
          }),
          howItWorksImageThird
        )}
      </div>
    </div>
  );
};

const { string } = PropTypes;

SectionHowItWorks.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionHowItWorks.propTypes = {
  className: string,
  rootClassName: string,
};

export default SectionHowItWorks;
